import Divider from "@mui/material/Divider/Divider";
import Grid from "@mui/material/Grid";
import { Controller, FormProvider, useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect, useState } from 'react';
import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import CustomSelect, { IOptions } from "../../components/FormFields/CustomSelect";
import { SelectChangeEvent } from "@mui/material/Select";
import { addUser, fetchUserByEmail } from '../../store/userThunk';
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { IUserFormInputs } from "../../utils/user.types";
import LoadingButton from "@mui/lab/LoadingButton";
import { ApiStatus } from "../../utils/api.types";
import { fetchRoles } from "../../store/rolesThunk";

import Autocomplete from "@mui/material/Autocomplete/Autocomplete";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography/Typography";
import { Avatar, List, ListItem, ListItemAvatar, ListItemText } from "@mui/material";

// // Form Input interface.
interface IUserAccountInvite {
  name: string;
  email: string;
  mobile: string;
  role: string;
};

export interface IDialogProps {
  title: string;
  open: boolean;
  onClose: () => void;
}

export default function UserInviteDialog(val: IDialogProps) {
  const dispatch = useAppDispatch();
  const { selectedAccount } = useAppSelector((state => state.auth));
  const [options, setOptions] = useState<any[]>([]);

  const [userRoles, setUserRoles] = useState<IOptions[]>(
    []
  );
  const [userRoleValues, setUserRoleValues] = useState("");
  const { status } = useAppSelector((state) => state.users);
  const [selected, setSelected] = useState(null);

  const schema = yup.object().shape({
    email: yup.string().email().required('Email is required.'),
    role: yup.string().required('Role is required.'),
  });

  useEffect(() => {
    const getRoles = async () => {
      const data: any = await dispatch(fetchRoles());
      const roles = Array.isArray(data?.payload) ? data.payload : [];
      setUserRoles(roles.map((c: any) => {
        return { label: c.role, value: c._id }
      }));
    }
    (getRoles());
  }, [dispatch]);

  const methods = useForm<IUserAccountInvite>({
    resolver: yupResolver(schema),
    mode: "all",
    shouldUnregister: true
  });
  const { control } = methods;

  const onSubmit = async (data: IUserAccountInvite) => {
    // Dispatch add account action.
    try {

      let submitData: IUserFormInputs = {
        name: data.name,
        email: data.email,
        roles: [data.role],
        isActive: false,
        accounts: [selectedAccount._id]
      };

      await dispatch(addUser(submitData)).unwrap();
      handleClose();
    } catch (error: any) {
      // Empty catch block.
    }
  };

  const resetForm = () => {
    setUserRoleValues('');
    setSelected(null);
    methods.reset({ 'name': '', 'email': '', 'role': '', 'mobile': '' });
  };

  const handleClose = () => {
    resetForm();
    val.onClose();
  };

  const loading = false;


  const onChangeHandle = async (value: any) => {
    let iUsersList: any = await dispatch(fetchUserByEmail({ email: value }));
    let optionsValue = (Array.isArray(iUsersList?.payload) ? iUsersList.payload : []).map((a: any) => { return { name: a.email, label: a.email, ...a } });
    setOptions(optionsValue);
  };

  return (
    <div>
      <Dialog open={val.open} onClose={handleClose} fullWidth>
        <FormProvider {...methods}>
          <DialogTitle>
            <Box sx={{ display: "flex", mt: 2, justifyContent: "space-between" }}>
              <Typography variant="h5">Member Invite</Typography>
            </Box>
          </DialogTitle>

          <DialogContent>


            <Grid container columnSpacing={1}>
              <Grid item md={12} xs={12}>
                {/* <CustomTextField label="Email" name="email" required /> */}
                <Controller
                  name='email'
                  control={control}
                  render={({ field }) => (
                    <Autocomplete
                      // value={selected}
                      {...field}
                      id="email"
                      value={selected}
                      onChange={(event, newValue) => {
                        let l = null;
                        if (newValue && !newValue.label) {
                          let t = newValue;
                          let g = { name: t, label: t };
                          let f: any = [...options, g];
                          l = t;
                          setOptions(f);
                        } else {
                          l = newValue.label;
                        }
                        setSelected(newValue);
                        field.onChange(l);
                      }}
                      onBlur={(event: any) => {
                        setSelected(event.target.value);
                        field.onChange(event.target.value);
                      }}
                      freeSolo
                      filterSelectedOptions
                      getOptionLabel={(optionLabel: any) => { return optionLabel.email || optionLabel; }}
                      options={options}
                      loading={loading}
                      renderOption={(option: any) => (
                        <React.Fragment>
                          <List sx={{ width: '100%', bgcolor: 'background.paper' }} dense {...option}>
                            <ListItem >
                              <ListItemAvatar>
                                <Avatar >{options[option['data-option-index']]['name'].slice(0, 1)}</Avatar>
                              </ListItemAvatar>
                              <ListItemText primary={options[option['data-option-index']]['name']}
                                secondary={options[option['data-option-index']]['email']} />
                            </ListItem>

                          </List>

                          <Divider light />
                          {/* {console.log(options[option['data-option-index']]['name'])} */}
                          {/* {options[option['data-option-index']]['name']} */}
                        </React.Fragment>
                      )}
                      renderInput={(params: any) => (
                        <TextField
                          {...params}
                          label="Search Member"
                          //name="email"
                          variant="standard"
                          required
                          value={selected}
                          onChange={(ev: any) => {
                            if (ev.target.value !== "" || ev.target.value !== null) {
                              onChangeHandle(ev.target.value);
                            }
                          }}
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <React.Fragment>
                                {loading ? (
                                  <CircularProgress key={params.InputProps.name} color="inherit" size={20} />
                                ) : null}
                                {params.InputProps.endAdornment}
                              </React.Fragment>
                            )
                          }}
                        />
                      )}
                    />
                  )}
                />
              </Grid>

              <Grid item md={12} xs={12}>
                <CustomSelect
                  name="role"
                  label="Role*"
                  required
                  id="industryVertical"
                  variant="standard"
                  options={userRoles}
                  value={userRoleValues ?? ""}
                  onChange={(event: SelectChangeEvent<any>) => {
                    // let sRole = userRoles.filter(f1 => f1.value == event.target.value)[0];
                    // let aOptions: IOptions[] = [{ "label": event.target.name, "value": event.target.value }];
                    setUserRoleValues(event.target.value);
                    methods.setValue("role", event.target.value, {shouldValidate: true});
                  }}
                />
              </Grid>
            </Grid>
          </DialogContent>

          <DialogActions>
            <Grid container justifyContent="right" spacing={3}>
              <Grid item xs={8} md={8} sm={8} lg={8}></Grid>

              <Grid item xs={2} md={2} sm={2} lg={2}>
                <Button variant='outlined'
                  onClick={handleClose}>
                  Cancel
                </Button>
              </Grid>

              <Grid item xs={2} md={2} sm={2} lg={2}>
                <LoadingButton
                  onClick={methods.handleSubmit(onSubmit)}
                  type="submit"
                  loading={status === ApiStatus.LOADING}
                  variant="contained"
                  color="secondary">
                  Invite
                </LoadingButton>
              </Grid>

            </Grid>
          </DialogActions>
        </FormProvider>
      </Dialog>
    </div>
  );
}
